import { FC, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { DropdownItem, DropdownMenu, ExportIconImg, IconImg } from './DropDownFormsExport.styled'

import PdfIcon from '@assets/images/pdf-icon.svg'
import UploadIcon from '@assets/images/upload-icon.svg'

import { ExportType } from '@utils/hooks'

import { Button } from '@components/Button'
import { DropDown } from '@components/DropDown'
import { useSendReportForms } from '@hooks/report/send-report-forms.hook'
import { FormReportInput } from '@types'
import { useSearchParams } from 'react-router-dom'
import { PopUpExportForms } from '../PopUpExportForms'

type DropDownFormsExportProps = {
  projectId: string
}

export const DropDownFormsExport: FC<DropDownFormsExportProps> = ({ projectId }) => {
  const { t } = useTranslation()
  const [searchParams] = useSearchParams()
  const { sendFormsReport } = useSendReportForms()

  const [showExportPopUp, setShowExportPopUp] = useState<boolean>(false)

  const exportOptions: {
    id: ExportType
    label: string
    icon: string
    onClick: () => void
  }[] = [
    {
      id: ExportType.PDF,
      label: 'PDF',
      icon: PdfIcon,
      onClick: () => handleExport(ExportType.PDF),
    },
  ]

  const handleExport = async (type: ExportType) => {
    if (type === ExportType.PDF) {
      setShowExportPopUp(true)
      return
    }
  }

  return (
    <>
      <DropDown
        disabled={status === 'loading'}
        WrappedComponent={() => (
          <Button isLoading={status === 'loading'}>
            <ExportIconImg src={UploadIcon} />
            {t('modules_project-settings_components_Planning_export')}
          </Button>
        )}
        WrappedChildren={({ hide }) => (
          <DropdownMenu
            onMouseMove={(event) => {
              event.stopPropagation()
            }}
          >
            {exportOptions.map(({ id, label, icon, onClick }) => (
              <DropdownItem
                key={id}
                onClick={() => {
                  onClick()
                  hide()
                }}
              >
                <IconImg src={icon} alt={label} />
                {label}
              </DropdownItem>
            ))}
          </DropdownMenu>
        )}
      />
      {showExportPopUp && (
        <PopUpExportForms
          onSubmit={(options) => {
            const filters = Object.fromEntries(searchParams.entries())
            const input: FormReportInput = {
              ...filters,
              ...options,
              projectId,
            }
            sendFormsReport(input)
            setShowExportPopUp(false)
          }}
          onClose={() => {
            setShowExportPopUp(false)
          }}
        />
      )}
    </>
  )
}
